import axios from "axios";
import config from "../../config/config";
import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import Select from "react-select";
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Link } from "react-router-dom";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";

function PayBillsEditData({ supplierid }) {
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchtext, setSearchText] = useState("");
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [sortingId, setSortingId] = useState(1);
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingDate,
    endingDate,
    supplierid,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);
    supplierid = supplierid > 0 ? supplierid : 0;
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/receivingpaymentlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startingDate}&enddate=${endingDate}&supplierid=${supplierid}&LocationID=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res.data.ResponseData", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false); // Set loading state to false after data is fetched
      })
      .catch((err) => {
        setLoading(false); // Set loading state to false in case of an error
      });
  };

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "27px",
  //     position: "relative",
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //   }),
  // };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      supplierid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  // console.log("supplierId:-------", supplierid);

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      supplierid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      supplierid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      supplierid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
    // console.log("ChangeFilter:---",handleListData);
  };

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const columns = useMemo(() => [
    {
      header: "BILL NO.",
      accessorKey: "BillNo",
      // enableGrouping: false, //do not let this column be grouped
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/receiving-receipt/${row.original.ReceivingID}`}
          >
            {row.original.BillNo}
          </Link>
        </>
      ),
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) => moment(row.original.DueDate).format("YYYY-MM-DD"),
    },
    {
      header: "Receiving Date",
      accessorKey: "ReceivingDate",
      Cell: ({ row }) =>
        moment(row.original.ReceivingDate).format("YYYY-MM-DD"),
    },
    {
      header: "Receive Type",
      accessorKey: "ReceivingsType",
    },
    {
      header: "Payment Date",
      accessorKey: "PaymentDate",
      Cell: ({ row }) => moment(row.original.PaymentDate).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      header: "Payment Type",
      accessorKey: "Paymenttypename",
    },
    {
      header: "Amount Paid",
      accessorKey: "PaymentAmount",
      Cell: ({ row }) => parseFloat(row.original.PaymentAmount).toFixed(2),
    },
    {
      header: "Carry Bill Amt.",
      accessorKey: "CarryForwordAmount",
      Cell: ({ row }) => parseFloat(row.original.CarryForwordAmount).toFixed(2),
    },
    {
      header: "Credit Applied",
      accessorKey: "CreditApplied",
      Cell: ({ row }) => parseFloat(row.original.CreditApplied).toFixed(2),
    },
    {
      header: "Bill Amount",
      accessorKey: "Total",
      Cell: ({ row }) => parseFloat(row.original.Total).toFixed(2),
    },
  ]);

  // Outstanding Table Column
  const outstandingColumns = [
    {
      name: "Sr.No.",
      selector: (row, index) => index + 1,
      width: "90px",
    },
    {
      name: "BILL NO.",
      selector: (row) => row["BillNo"],
      sortable: true,
      width: "135px",
    },
    {
      name: "Due Date",
      selector: (row) =>
        row.DueDate == null || row.DueDate == "0000-00-00"
          ? ""
          : moment(row.DueDate).format("YYYY-MM-DD"),
      sortable: true,
      width: "130px",
    },
    {
      name: "Receiving Date",
      selector: (row) =>
        row.ReceivingDate == null
          ? ""
          : moment(row.ReceivingDate).format("YYYY-MM-DD"),
      sortable: true,
      width: "165px",
    },
    {
      name: "Receive Type",
      selector: "ReceivingsType",
      sortable: true,
      width: "150px",
    },
    {
      name: "Payment Date",
      selector: (row) =>
        row.PaymentDate == null
          ? ""
          : moment(row.PaymentDate).format("YYYY-MM-DD"),
      sortable: true,
      width: "165px",
    },
    {
      name: "Payment Type",
      selector: "Paymenttypename",
      width: "165px",
      sortable: true,
    },
    {
      name: "Amount Paid",
      selector: (row) => parseFloat(row["PaymentAmount"]).toFixed(2),
      width: "150px",
      // sortable: true,
      right: true,
    },
    {
      name: "Carry Bill Amt.",
      selector: (row) => parseFloat(row["CarryForwordAmount"]).toFixed(2),
      width: "150px",
      right: true,
    },
    {
      name: "Credit Applied",
      selector: (row) => parseFloat(row["CreditApplied"]).toFixed(2),
      width: "150px",
      // sortable: true,
      right: true,
    },
    {
      name: "Bill Amount",
      selector: (row) => parseFloat(row["Total"]).toFixed(2),
      width: "150px",
      // sortable: true,
      right: true,
    },
  ];

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      supplierid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  const handleChangeCustomStartingDate = (event) => {
    // console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (event) => {
    event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    // console.log(event, "quick book data");

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value !== 2) {
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        startingDate,
        endingDate,
        supplierid,
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    }
  }, [
    supplierid,
    quickBookOptions,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    } else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //current Month
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  return (
    <>
      <div className="">
        <div className="card bg-white">
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap">
                <div className="p-2 col-lg-2 col-md-6 col-sm-12">
                  Search:
                  <input
                    type="search"
                    placeholder="Search..."
                    className="form-control"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  ></input>
                </div>
                <div className="p-2 col-lg-2 col-md-6 col-sm-12">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-2 col-lg-3 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-2 col-lg-3 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                    <div className="p-4 mt-1 col-lg-1 col-md-6 col-sm-12">
                      <button
                        className="btn btn-dark"
                        onClick={() => handleSearchAccordingToDate()}
                      >
                        {" "}
                        Search{" "}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="card-body">
            {true && (
              <>
                <div style={{ fontSize: "20px", paddingLeft: "10px" }}>
                  Pay Bills
                </div>
                <div className="table-responsive">
                  {/* <DataTable
                    title="Pay Bills"
                    columns={outstandingColumns}
                    data={data}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    onChangePage={handlePageChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    persistTableHead
                    sortServer
                    onSort={handleSort}
                    dense
                  /> */}
                  <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    // enableRowSelection
                    enableColumnOrdering
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    initialState={{
                      density: "compact",
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "Date", desc: false }], //sort by Date by default
                    }}
                    // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                    // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                    muiPaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      isError
                        ? {
                            color: "error",
                            children: "Error loading data",
                          }
                        : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={totalRows}
                    state={{
                      columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PayBillsEditData;
